import { useState } from "react";
import { connect } from "react-redux";

import { programLevels } from "../../constants";

import { Clock, Plus, Running, RectangleList, Dumbbell } from "../../common/CustomIcons";
import { TbStack2 } from "react-icons/tb";
import { AiOutlineLineChart, AiOutlineClockCircle, AiOutlineUnorderedList, } from "react-icons/ai";
import MetaIcons from "./MetaIcons";
import CustomButton from "../../common/CustomButton";

function ProgramDescription(props) {
    let { selectedProgram, screenSize, progWorkouts, actionAdd = null, actionGoToPrograms = null, actionGoToWorkouts = null, getStarted = null } = props;
    const [clicked, setClicked] = useState(false);
    const { user } = props.User;

    if (selectedProgram?.level) {
        progWorkouts = progWorkouts.filter((pw) => pw.program_detail_id == selectedProgram?.level * 1)
    }

    let selectedProgramsKeys = user?.selected_program?.split(",");
    const id = selectedProgram?.id;
    const level = selectedProgram?.level;
    const key = id + (level && level != 0 ? ("-" + level) : "");


    const added = selectedProgramsKeys?.indexOf(key) > -1;

    const levelW = programLevels[selectedProgram?.level];


    let allDur = 0;
    for (let x = 0; x < progWorkouts.length; x++) {
        allDur = allDur + progWorkouts[x].video_time;
    }
    allDur = Math.round(allDur / progWorkouts.length / 60);

    let gradient = selectedProgram?.gradient?.split("-");
    return (
        <div className="detail-description">
            <h2 id="dd-program-name">{selectedProgram?.title} {levelW ? (" - " + levelW.toLowerCase()) : ""}</h2>
            <div id="dd-program-type" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}><h6>{selectedProgram?.type}</h6></div>
            {
                screenSize != "xl"
                    ? <div id="detail-description-icons">
                        <div>
                            <h4>{selectedProgram?.count}</h4>
                            <h6>WORKOUTS</h6>
                        </div>
                        <div>
                            <h4>{selectedProgram?.time}m</h4>
                            <h6>AVG LENGTH</h6>
                        </div>
                        {/* <div>
                            <h4>{"3/10"}</h4>
                            <h6>DIFFICULTY</h6>
                        </div> */}
                    </div>
                    : <>
                        <div id="detail-description-icons2">
                            <div>
                                <h5>WORKOUTS:</h5>
                                <p>{selectedProgram?.count}</p>
                            </div>
                            <div>
                                <h5>AVG LENGTH:</h5>
                                <p>{selectedProgram?.time}m</p>
                            </div>
                            {/* {
                                selectedProgram?.beginner &&
                                <div>
                                    <h5>DIFFICULTY:</h5>
                                    <p>{programLevels[selectedProgram?.level]}</p>
                                </div>
                            } */}
                        </div>
                    </>
            }

            <div>
                {/* <h5>ABOUT</h5> */}
                {
                    (!levelW ? selectedProgram?.info : selectedProgram[levelW.toLowerCase()])?.split("|").map((p) => {
                        return (

                            <p>
                                {p}
                            </p>
                        )
                    })
                }
            </div>

            {
                screenSize == "xl" &&
                <div id="detail-description-actions">
                    {
                        !added &&
                        // true &&
                        <div style={{ display: "flex" }}>
                            {
                                actionGoToWorkouts && <div style={{ marginRight: "10px" }}>
                                    <CustomButton onClick={() => {
                                        actionGoToWorkouts()
                                    }}>
                                        <Dumbbell />Try It
                                    </CustomButton>
                                </div>
                            }
                            {
                                actionAdd && <div>
                                    <CustomButton onClick={() => {
                                        setClicked(true);
                                        if (!clicked) {
                                            actionAdd()
                                        }
                                    }} className="active">
                                        <Plus />Add Program
                                    </CustomButton>
                                </div>
                            }
                        </div>
                    }

                    {
                        actionGoToPrograms && <div><button onClick={() => {
                            actionGoToPrograms();
                        }} className="secondary-button">Explore More Programs</button></div>
                    }

                </div>
            }
        </div>
    );
}


const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
})(ProgramDescription);